<template>
  <div id="main">
    <v-index>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>设置</el-breadcrumb-item>
        <el-breadcrumb-item><a style="color: #000000;">流程审批人员</a></el-breadcrumb-item>
      </el-breadcrumb>

      <v-weburl-iframe url="setting/audit_member" />
    </v-index>
  </div>
</template>

<script>
import VIndex from "@/components/common";
import VWeburlIframe from "@/components/weburl-iframe";
export default {
  name: "systemProcessMember",
  components: {VWeburlIframe, VIndex}
}
</script>

<style scoped>

</style>